/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Whole_Word_LabelInputs */

const en_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whole Word`)
};

const fr_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot entier`)
};

const de_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganzes Wort`)
};

const it_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parola intera`)
};

const ru_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целое Слово`)
};

const es_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palabra completa`)
};

const zh_cn2_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整个单词`)
};

const ja_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語全体`)
};

const hi_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा शब्द`)
};

const pt_pt2_find_replace_whole_word_label = /** @type {(inputs: Find_Replace_Whole_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavra inteira`)
};

/**
* | output |
* | --- |
* | "Whole Word" |
*
* @param {Find_Replace_Whole_Word_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_whole_word_label = /** @type {((inputs?: Find_Replace_Whole_Word_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Whole_Word_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_whole_word_label(inputs)
	if (locale === "de") return de_find_replace_whole_word_label(inputs)
	if (locale === "it") return it_find_replace_whole_word_label(inputs)
	if (locale === "ru") return ru_find_replace_whole_word_label(inputs)
	if (locale === "es") return es_find_replace_whole_word_label(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_whole_word_label(inputs)
	if (locale === "ja") return ja_find_replace_whole_word_label(inputs)
	if (locale === "hi") return hi_find_replace_whole_word_label(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_whole_word_label(inputs)
	return en_find_replace_whole_word_label(inputs)
});